import React from 'react';
import type { RouteObject } from 'react-router-dom';

const CalendarPage = React.lazy(() => import('@/pages/calendar'));

export const calendarRoutes: RouteObject[] = [
  {
    path: 'calendar',
    element: <CalendarPage />,
  },
];
